export const environment = {
	production: true,
	url: 'https://api.qa.app.kosaas-mmi.com:3000'
};
